import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class KfiRouterService {
  constructor(protected readonly router: Router) {}

  public redirectAfterSubmit(caseNumber: string): void {
    void this.router.navigate([`/caseOverview`, caseNumber, 'caseAdvice']);
  }
}
